<template>
  <div class="progressbar-wrapper" v-if="steps">
    <ul class="progressbar">
      <li class="item" v-for="(step, i) in steps" :key="i" :class="{ active: active >= i + 1 }"><span class="step">{{ step }}</span></li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'ProgressStep',

    props: {
      steps: {
        type: Array,
        default: null
      },
      active: {
        type: Number,
        default: 1
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ProgressStep.vue?7ba1272e